import { render, staticRenderFns } from "./SetariContracteProductie.vue?vue&type=template&id=f04fa4a6&scoped=true"
import script from "./SetariContracteProductie.vue?vue&type=script&lang=js"
export * from "./SetariContracteProductie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04fa4a6",
  null
  
)

export default component.exports